export enum UserRole {
  ADMIN = 'admin',
  companyAdmin = 'companyAdmin',
  projectAdmin = 'projectAdmin',
  project = 'project',
  KOBO = 'kobo',
  NGO = 'ngo',
  COMPANY = 'company',
}
